import NextImage from "@components/NextImage";
import {useTranslation} from "ni18n";
import React from "react";

type ImageItemProps = React.HTMLAttributes<HTMLDivElement> & ImageItem;

const ImageItem: React.FunctionComponent<ImageItemProps> = ({
  header,
  content,
  image,
  className,
  step,
}): React.ReactElement => {
  const i18n = useTranslation();
  return (
    <li className={`mb16 mb10-md ph4 ph0-md ${className}`}>
      <NextImage src={image.src} height={image.height} width={image.height} alt="" />
      {Number.isInteger(step) && (
        <div className="darkGreen ttu font-im">{i18n.t("Step {{number}}", {number: step})}</div>
      )}
      <h2 className="font-cm fs28 fs20-md lh12 mt2 mb3 mb1-md gray800 maxw18-md">{header}</h2>
      <p className="lh14 fs16-md font-ir gray600 maxw25 maxw16-md">{content}</p>
    </li>
  );
};

export type ImageItem = {
  header: string;
  content: string;
  step?: number;
  image: {
    src: string;
    height: number;
    alt?: string | null;
  };
};

interface ImageItemListProps {
  items: ImageItem[];
  rows: number;
  itemClassName?: string;
  showSteps?: boolean;
}

export const ImageItemList: React.FunctionComponent<ImageItemListProps> = ({
  items,
  rows = 1,
  itemClassName = "",
  showSteps = false,
}) => (
  <ul className={`df jcsb fdc-md ${rows > 1 && "fw"}`}>
    {items.map((item, key) => (
      <ImageItem
        // @ts-expect-error TS2322: Type 'number | false' is not assignable to type 'number | undefined'.
        step={showSteps && key + 1}
        key={key}
        {...item}
        className={`${itemClassName} ${rows === 2 && "w50p w100p-md"}`}
      />
    ))}
  </ul>
);
